{
  "en": {
    "task_assignment": {
      "actions": {
        "confirm": "Mark as done",
        "create": "Task",
        "move_to_draft": "Move to draft",
        "reopen": "Reopen",
        "send_and_notify": "Send and notify"
      },
      "assignee_types": {
        "customer": "Customer",
        "employee": "Employee",
        "partner": "Partner"
      },
      "attributes": {
        "assignee": "Assignee",
        "assignees": "Assignees",
        "created_at": "Created",
        "due_date": "Due date",
        "project": "Project",
        "status": "Status",
        "task": "Task",
        "unit": "Unit"
      },
      "confirm": {
        "affected": "This affects {customers} and {team}.",
        "affected_customers": "This affects {customers}.",
        "affected_team": "This affects {team}.",
        "complete_body": "Their tasks are closed for them and disappear from their list, even if they never acted.",
        "complete_header": "Close this task for everyone?",
        "customer_tasks": "{count} customer task | {count} customer tasks",
        "draft_body": "The task disappears until it is sent again. Emails that already went out stay sent.",
        "draft_header": "Move this task back to draft?",
        "send_customers": "Customers see the task in their portal straight away and are notified.",
        "send_header": "Send to the assignees?",
        "send_permanent": "Sending cannot be undone. Moving the task back to draft later does not take the notification back.",
        "send_status": "They land on Requested.",
        "send_team": "Team members are notified.",
        "team_tasks": "{count} team task | {count} team tasks"
      },
      "labels": {
        "add_assignee": "Add an assignee…",
        "add_customers": "Add customers",
        "already_assigned": "This task is already added to this unit.",
        "already_assigned_project": "This task is already added to this project.",
        "completed": "Completed",
        "confirm_message": "Are you sure you want to mark this task as done?",
        "customers": "Customers",
        "my_tasks": "My tasks",
        "no_assignees": "No assignees yet.",
        "no_assignments": "No tasks yet.",
        "no_assignments_task": "No assignments for this task yet.",
        "no_assignments_unit": "No tasks for this unit yet.",
        "required": "This field is required",
        "select_task": "Select a task",
        "upload_hint": "Upload the requested document(s) to complete this task.",
        "uploaded_documents": "Uploaded documents"
      },
      "statuses": {
        "completed": "Completed",
        "draft": "Draft",
        "requested": "Requested"
      },
      "toasts": {
        "completed": "Task completed",
        "create": "Task created",
        "delete": "Task deleted",
        "reopened": "Task reopened",
        "update": "Task updated"
      }
    }
  }
}
